import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectLogin } from '../../../../store/login/loginSlice';
import { Link as RouterLink } from 'react-router-dom';
import { CustomGrid, CustomInfosForm } from '../../../../assets/style/globalStyle';
import { NotificationManager } from 'react-notifications';
import { isMobile } from 'react-device-detect';
import { viaCep, validCep } from '../../../../@core/utils/utilsFunctions';
import { validateCNPJ } from '../../../../@core/utils/utilsFunctions';
import {
  Stack,
  Typography,
  Card,
  Button,
  TextField,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Tab,
  Alert
} from '@mui/material';

import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

import AddEditDocuments from './addEditDocuments';
import FormConfigPanel from '../leads/FormConfig';

import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import configAxios from '../../../../services/configAxios';
import InputMask from 'react-input-mask';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';

const allowedPageSizes = [5, 10, 20, 30];

import { selectClient } from '../../../../store/login/loginSlice';

const Config = (props) => {
  const [infosConfig, setInfosConfig] = useState({});
  const [values, setValues] = useState('1');
  const infoStateTemp = useSelector(selectLogin);
  const [infoState] = useState({ ...infoStateTemp.userLoggedIn[0] });

  const [openModal, setOpenModal] = useState(false);
  const [infosDocs, setInfosDocs] = useState([]);
  const [infosDocEdit, setInfosDocEdit] = useState([]);

  const company = useSelector(selectClient);

  useEffect(() => {
    getConfig();
    getDocs();
  }, []);

  function getConfig() {
    configAxios
      .get('/config/getConfig')
      .then((response) => {
        setInfosConfig(response.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades buscar as configurações no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function validCNPJ(event) {
    if (event.target.value) {
      const cnpjIsValid = validateCNPJ(event.target.value);
      if (!cnpjIsValid) {
        NotificationManager.warning('CNPJ inválido, por favor verifique!', 'Atenção');
        setInfosConfig({ ...infosConfig, cnpj: '' });
        return;
      }
      setInfosConfig({ ...infosConfig, [event.target.name]: event.target.value });
    }
  }

  async function HandleUploadImage(event) {
    if (event) {
      const formData = new FormData();

      formData.append('file', event.target.files[0]);

      configAxios
        .post('/config/updateLogo', formData)
        .then(() => {
          NotificationManager.success('Imagem atualizada com sucesso!', 'Sucesso');
          getConfig();
        })
        .catch(() => {
          NotificationManager.error(
            'Tivemos dificuldades atualizar a imagem, tente novamente!',
            'Atenção'
          );
        });
    }
  }

  async function HandleInputCep(event) {
    if (event.target.value) {
      if (validCep(event.target.value)) {
        let infosCep;
        infosCep = await viaCep(event.target.value);
        if (infosCep) {
          HandleInputChange({ ...infosCep }, true);
          return;
        }
        NotificationManager.danger(
          'Tivemos dificuldades para buscar as informações do endereço, tente novamente!',
          'Atenção'
        );
      } else {
        NotificationManager.warning('Cep inválido, verifique e tente novamente!', 'Atenção');
      }
    }
  }

  function HandleInputChange(event, cep) {
    if (cep) {
      setInfosConfig({ ...infosConfig, ...event });
      return;
    }
    setInfosConfig({ ...infosConfig, [event.target.name]: event.target.value });
  }

  function HandleSubmit(event) {
    event.preventDefault();
    const router = '/config/updateConfig';

    configAxios
      .post(router, infosConfig)
      .then(() => {
        NotificationManager.success('Configurações atualizadas com sucesso!', 'Sucesso');
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function getDocs() {
    const router = '/docs/listDocs';
    configAxios
      .get(router)
      .then((result) => {
        setInfosDocs(result.data);
      })
      .catch(() => {
        NotificationManager.error(
          'Tivemos dificuldades atender a requisição no momento, tente novamente!',
          'Atenção'
        );
      });
  }

  function handleTabsChange(event, newValue) {
    setValues(newValue);
  }

  function ActionsButtons(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          disabledEdit: true,
          deleteRouter: '/docs/deleteDoc',
          deleteItem: 'o documento',
          functionGrid: getDocs,
          router: 'updateDoc',
          functionModal: DocumentsModal,
          otherInfos: item
        }}
      />
    ));
  }

  function DocumentsModal(id) {
    if (id) {
      const valuesEdit = infosDocs.filter((element) => element.id === id);
      if (valuesEdit.length > 0) {
        if (valuesEdit[0].obrigatorio === false) {
          valuesEdit[0].obrigatorio = 'false';
        }
        setInfosDocEdit(valuesEdit[0]);
      }
    }
    setOpenModal(true);
  }

  return (
    <RenderPage title="Configurações" id="configs">
      <>
        <AddEditDocuments
          openModal={openModal}
          setOpenModal={setOpenModal}
          infosItemEdit={infosDocEdit}
          functionGrid={getDocs}
        />

        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Configurações gerais
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo editar as configurações e informações do sistema
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
            {!isMobile && (
              <Button
                variant="outlined"
                color="error"
                component={RouterLink}
                to="/app/dashboard"
                startIcon={<Iconify icon="eva:arrow-back-fill" />}>
                Voltar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <Box sx={{ width: '100%' }}>
              <TabContext value={values}>
                <Box>
                  <TabList
                    onChange={handleTabsChange}
                    aria-label="ClientsTabs"
                    variant="scrollable"
                    scrollButtons="auto">
                    <Tab label="Configurações" value="1" />
                    <Tab label="Parâmetros" value="2" />
                    <Tab
                      sx={{ textTransform: 'none' }}
                      label="Documentos/Uploads das propostas"
                      value="3"
                    />
                    <Tab
                      sx={{ textTransform: 'none' }}
                      label="Alerta de declínio de propostas"
                      value="4"
                    />
                    <Tab
                      sx={{ textTransform: 'none' }}
                      label="Configurações do Formulário"
                      value="5"
                    />
                  </TabList>
                </Box>
                <form onSubmit={HandleSubmit}>
                  <TabPanel value="1">
                    <Box sx={{ width: '100%', border: 1, borderColor: 'grey.200', p: 1 }}>
                      <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={3.5}>
                          <TextField
                            name="razaosocial"
                            fullWidth
                            label="Razão social"
                            variant="outlined"
                            size="small"
                            required
                            value={infosConfig.razaosocial || ''}
                            onChange={(event) => HandleInputChange(event)}
                            inputProps={{ maxLength: 100 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={3.5}>
                          <TextField
                            name="nomefantasia"
                            fullWidth
                            label="Nome fantasia"
                            variant="outlined"
                            size="small"
                            required
                            value={infosConfig.nomefantasia || ''}
                            onChange={(event) => HandleInputChange(event)}
                            inputProps={{ maxLength: 100 }}
                          />
                        </Grid>
                        <Grid item xs={12} md={2.3}>
                          <InputMask
                            mask="**.***.***/****-99"
                            formatChars={{
                              '*': '[A-Z0-9]',
                              9: '[0-9]'
                            }}
                            value={infosConfig.cnpj || ''}
                            onChange={(event) => HandleInputChange(event)}
                            onBlur={(event) => validCNPJ(event)}>
                            {() => (
                              <TextField
                                name="cnpj"
                                fullWidth
                                label="CNPJ"
                                required
                                variant="outlined"
                                size="small"
                              />
                            )}
                          </InputMask>
                        </Grid>
                        <Grid item xs={12} md={2.7}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Regime tributário *
                          </InputLabel>
                          <Select
                            name="id_regime"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.id_regime || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'1'}>Micro empreendedor Individual</MenuItem>
                            <MenuItem value={'2'}>Simples Nacional</MenuItem>
                            <MenuItem value={'3'}>Lucro Presumido</MenuItem>
                            <MenuItem value={'4'}>Lucro Real</MenuItem>
                          </Select>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12} md={2}>
                          <InputMask
                            mask="99999-999"
                            onChange={(event) => HandleInputChange(event)}
                            onBlur={(event) => HandleInputCep(event)}
                            value={infosConfig.cep || ''}>
                            {() => (
                              <TextField
                                name="cep"
                                fullWidth
                                label="CEP"
                                variant="outlined"
                                size="small"
                                required
                              />
                            )}
                          </InputMask>
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="rua"
                            fullWidth
                            label="Rua"
                            disabled
                            required
                            size="small"
                            variant="outlined"
                            value={infosConfig.rua || ''}
                            onChange={(event) => HandleInputChange(event)}
                          />
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <TextField
                            name="numero"
                            fullWidth
                            label="Número"
                            value={infosConfig.numero || ''}
                            required
                            size="small"
                            variant="outlined"
                            type="number"
                            onChange={(event) => HandleInputChange(event)}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="complemento"
                            fullWidth
                            label="Complemento"
                            size="small"
                            value={infosConfig.complemento || ''}
                            variant="outlined"
                            onChange={(event) => HandleInputChange(event)}
                            inputProps={{ maxLength: 100 }}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{ mt: 1, mb: 2 }}>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="bairro"
                            fullWidth
                            label="Bairro"
                            required
                            size="small"
                            variant="outlined"
                            value={infosConfig.bairro || ''}
                            inputProps={{ maxLength: 100 }}
                            onChange={(event) => HandleInputChange(event)}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="cidade"
                            fullWidth
                            label="Cidade"
                            disabled
                            variant="outlined"
                            size="small"
                            required
                            value={infosConfig.cidade || ''}
                            onChange={(event) => HandleInputChange(event)}
                          />
                        </Grid>
                        <Grid item xs={12} md={4}>
                          <TextField
                            name="estado"
                            fullWidth
                            label="Estado"
                            disabled
                            required
                            size="small"
                            variant="outlined"
                            value={infosConfig.estado || ''}
                            onChange={(event) => HandleInputChange(event)}
                          />
                        </Grid>
                      </Grid>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={2} sx={{ mt: 5 }}>
                          {infosConfig.id && (
                            <Box
                              component="img"
                              sx={isMobile ? { width: '65%', mt: 1 } : { width: '80%', mt: 1 }}
                              src={`${infosConfig.logo}??${new Date().getTime()}`}
                            />
                          )}
                          <Button
                            variant="outlined"
                            size="medium"
                            component="label"
                            sx={{ mt: 2, textTransform: 'none' }}>
                            Alterar imagem
                            <input
                              type="file"
                              hidden
                              accept="image/*"
                              onChange={HandleUploadImage}
                              onClick={(event) => (event.target.value = null)}
                            />
                          </Button>
                        </Grid>
                        <Grid item xs={12} md={2} sx={isMobile ? { mt: 3 } : { mt: 8 }}>
                          {infosConfig.id && (
                            <TextField
                              name="corprimaria"
                              fullWidth
                              label="Cor primária"
                              required
                              size="small"
                              type="color"
                              variant="outlined"
                              value={infosConfig.corprimaria || ''}
                              onChange={(event) => HandleInputChange(event)}
                            />
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </TabPanel>
                  <TabPanel value="2">
                    <Alert severity="error">
                      Informações sensíveis, tenha absoluta certeza antes de alterar, alterações
                      indevidas podem impactar as rotinas do sistema!
                    </Alert>
                    <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 1 }}>
                      <CustomInfosForm>Campos obrigatórios possuem asterisco (*)</CustomInfosForm>
                      <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} md={2.2}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Tipo de operação *
                          </InputLabel>
                          <Select
                            name="tipooperacao"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.tipooperacao || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Operadora'}>Operadora de saúde</MenuItem>
                            <MenuItem value={'Administradora'}>Administradora de planos</MenuItem>
                            <MenuItem value={'Odonto'}>Plano odontológico</MenuItem>
                            <MenuItem value={'Cartão'}>Cartão de benefícios</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.2}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Tipo *
                          </InputLabel>
                          <Select
                            name="tipo"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.tipo || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Simples'}>Simples</MenuItem>
                            <MenuItem value={'Simples c/odonto'}>Simples c/ odonto</MenuItem>
                            <MenuItem value={'Complexo'}>Complexo</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.8}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Controla código de contrato ? *
                          </InputLabel>
                          <Select
                            name="controlacontrato"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.controlacontrato || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Modalidade de contratos *
                          </InputLabel>
                          <Select
                            name="modalidadecontrato"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.modalidadecontrato || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            {/* <MenuItem value={'Contrato único'}>Contrato único</MenuItem> */}
                            <MenuItem value={'Contrato por plano'}>Contrato por plano</MenuItem>
                            <MenuItem value={'Contrato por tipo de contratação'}>
                              Contrato por modalidade
                            </MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.6}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Controla subestipulante ? *
                          </InputLabel>
                          <Select
                            name="controlasubestipulante"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.controlasubestipulante || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.9}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Controla mudança de carência ? *
                          </InputLabel>
                          <Select
                            name="controlamudancacarencia"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.controlamudancacarencia || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.3}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Libera carência ? *
                          </InputLabel>
                          <Select
                            name="liberacarencia"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.liberacarencia || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} md={1.6}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Entrevista qualificada ? *
                          </InputLabel>
                          <Select
                            name="entrevisqualificada"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.entrevisqualificada || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.5}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Controla associação ? *
                          </InputLabel>
                          <Select
                            name="controlaassociacao"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.controlaassociacao || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.4}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Controla comissão ? *
                          </InputLabel>
                          <Select
                            name="controlacomissao"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.controlacomissao || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.6}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Controla código gerente ? *
                          </InputLabel>
                          <Select
                            name="controlagerente"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.controlagerente || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.3}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Controla CAEPF ? *
                          </InputLabel>
                          <Select
                            name="controlacaepf"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.controlacaepf || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.3}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Multiplos planos ? *
                          </InputLabel>
                          <Select
                            name="multiplosplanos"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.multiplosplanos || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.6}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Obriga seleção do grupo ? *
                          </InputLabel>
                          <Select
                            name="obrigagrupo"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.obrigagrupo || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.7}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Indica empresa/contrato ? *
                          </InputLabel>
                          <Select
                            name="indicaempresacontrato"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.indicaempresacontrato || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                      </Grid>
                      <Grid container spacing={2} sx={{ mt: 2, mb: 1 }}>
                        <Grid item xs={12} md={2.3}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Indica mês de reajuste da associação ? *
                          </InputLabel>
                          <Select
                            name="indicamesreaj"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.indicamesreaj || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Gera recibo ? *
                          </InputLabel>
                          <Select
                            name="gerarecibo"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.gerarecibo || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.7}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Notifica adm da corretora ? *
                          </InputLabel>
                          <Select
                            name="notificaadm"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.notificaadm || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.7}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Exclui declaração de saúde ? *
                          </InputLabel>
                          <Select
                            name="excluirdeclaracaosaude"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.excluirdeclaracaosaude || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={2.1}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Solicita assinatura pelo whatsApp ? *
                          </InputLabel>
                          <Select
                            name="solicitawhatsapp"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.solicitawhatsapp || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.5}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Tipo de integração *
                          </InputLabel>
                          <Select
                            name="tipointegracao"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.tipointegracao || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Própria'}>Própria</MenuItem>
                            <MenuItem value={'Terceiros'}>Terceiros</MenuItem>
                            <MenuItem value={'Não possui'}>Não possui</MenuItem>
                          </Select>
                        </Grid>
                        {infosConfig.tipointegracao === 'Própria' && (
                          <>
                            <Grid item xs={12} md={1.7}>
                              <InputLabel
                                id="label"
                                sx={
                                  isMobile
                                    ? { fontSize: '13px', mt: 0 }
                                    : { fontSize: '13px', mt: -2.2 }
                                }>
                                Modelo integração *
                              </InputLabel>
                              <Select
                                name="modelointegracao"
                                fullWidth
                                size="small"
                                required
                                value={infosConfig.modelointegracao || ''}
                                onChange={(event) => HandleInputChange(event)}>
                                <MenuItem value={'Novo'}>Novo (web)</MenuItem>
                                <MenuItem value={'Antigo'}>Antigo (local)</MenuItem>
                              </Select>
                            </Grid>
                          </>
                        )}
                        {infosConfig.tipointegracao !== 'Não possui' && (
                          <>
                            <Grid item xs={12} md={2} sx={{ mt: 1.5 }}>
                              <InputLabel
                                id="label"
                                sx={
                                  isMobile
                                    ? { fontSize: '13px', mt: 0 }
                                    : { fontSize: '13px', mt: -2.2 }
                                }>
                                Status da integração
                              </InputLabel>
                              <Select
                                name="statusintegracao"
                                fullWidth
                                size="small"
                                required
                                value={infosConfig.statusintegracao || ''}
                                onChange={(event) => HandleInputChange(event)}>
                                <MenuItem value={'Aberta'}>Aberta</MenuItem>
                                <MenuItem value={'Análise'}>Análise</MenuItem>
                                <MenuItem value={'Aguardando cliente'}>Aguardando cliente</MenuItem>
                                <MenuItem value={'Aguardando corretora'}>
                                  Aguardando corretora
                                </MenuItem>
                                <MenuItem value={'Aguardando operadora'}>
                                  Aguardando operadora
                                </MenuItem>
                                {infoState.tipo === 'Complexo' && (
                                  <MenuItem value={'Aguardando administradora'}>
                                    Aguardando administradora
                                  </MenuItem>
                                )}
                                <MenuItem value={'Aprovada'}>Aprovada</MenuItem>
                                <MenuItem value={'Negada'}>Negada</MenuItem>
                                <MenuItem value={'Cancelada pelo proponente'}>
                                  Cancelada (Proponente)
                                </MenuItem>
                              </Select>
                            </Grid>
                            <Grid item xs={12} md={10} sx={{ mt: 1.5 }}>
                              <TextField
                                name="rotapostback"
                                fullWidth
                                label="Rota de postaback"
                                required
                                size="small"
                                variant="outlined"
                                value={infosConfig.rotapostback || ''}
                                onChange={(event) => HandleInputChange(event)}
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                      <Grid container spacing={2}>
                        {infosConfig.tipointegracao !== 'Não possui' && (
                          <>
                            <Grid item xs={12} md={12} sx={{ mt: 1.5 }}>
                              <TextField
                                name="tokenpostback"
                                label="Token de autenticação da integração"
                                fullWidth
                                required
                                size="small"
                                variant="outlined"
                                value={infosConfig.tokenpostback || ''}
                                onChange={(event) => HandleInputChange(event)}
                              />
                            </Grid>
                          </>
                        )}
                        {infosConfig.solicitawhatsapp === 'Sim' && (
                          <>
                            <Grid item xs={12} md={12} sx={{ mt: 0.5 }}>
                              <TextField
                                name="tokenwhatsapp"
                                label="Token de integração whatsApp"
                                fullWidth
                                required
                                size="small"
                                variant="outlined"
                                value={infosConfig.tokenwhatsapp || ''}
                                onChange={(event) => HandleInputChange(event)}
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>
                      <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} md={1.5}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Integra direct data ? *
                          </InputLabel>
                          <Select
                            name="integradirectdata"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.integradirectdata || 'Não'}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        {infosConfig.integradirectdata === 'Sim' && (
                          <>
                            <Grid item xs={12} md={2}>
                              <TextField
                                name="quantidadeintegracaodirectadata"
                                label="Limite de integração direct data"
                                fullWidth
                                disabled
                                size="small"
                                variant="outlined"
                                type="number"
                                value={infosConfig.quantidadeintegracaodirectadata || ''}
                              />
                            </Grid>
                          </>
                        )}
                        <Grid item xs={12} md={1.5}>
                          <InputLabel
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Consulta blacklist ? *
                          </InputLabel>
                          <Select
                            name="consultablacklist"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.consultablacklist || 'Não'}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <InputLabel
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Realiza análise médica ? *
                          </InputLabel>
                          <Select
                            name="analisemedica"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.analisemedica || 'Não'}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.5}>
                          <InputLabel
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Inclui agravos ? *
                          </InputLabel>
                          <Select
                            name="incluiagravo"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.incluiagravo || 'Não'}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={1.5}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Integra com o cal ? *
                          </InputLabel>
                          <Select
                            name="integracal"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.integracal || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={2}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Integra com terceiros Mplan ? *
                          </InputLabel>
                          <Select
                            name="integraterceiros"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.integraterceiros || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        {infosConfig.integradirectdata === 'Não' && (
                          <Grid item xs={12} md={2}>
                            <InputLabel
                              id="label"
                              sx={
                                isMobile
                                  ? { fontSize: '13px', mt: 0 }
                                  : {
                                      fontSize: '13px',
                                      mt: infosConfig.integradirectdata == 'Sim' ? 0.53 : -2.2
                                    }
                              }>
                              Controla regiões ? *
                            </InputLabel>
                            <Select
                              name="controlaregiao"
                              fullWidth
                              size="small"
                              required
                              value={infosConfig.controlaregiao || ''}
                              onChange={(event) => HandleInputChange(event)}>
                              <MenuItem value={'Sim'}>Sim</MenuItem>
                              <MenuItem value={'Não'}>Não</MenuItem>
                            </Select>
                          </Grid>
                        )}
                      </Grid>
                      <Grid container spacing={2} sx={{ mt: 0.5 }}>
                        {infosConfig.integraterceiros === 'Sim' && (
                          <>
                            <Grid item xs={12} md={12} sx={{ mt: 0.5 }}>
                              <TextField
                                name="tokenterceiros"
                                label="Token de integração com terceiros"
                                fullWidth
                                required
                                size="small"
                                variant="outlined"
                                value={infosConfig.tokenterceiros || ''}
                                onChange={(event) => HandleInputChange(event)}
                              />
                            </Grid>
                          </>
                        )}
                      </Grid>

                      <Grid container spacing={2} sx={{ mt: 2 }}>
                        {infosConfig.integradirectdata === 'Sim' && (
                          <Grid item xs={12} md={2}>
                            <InputLabel
                              id="label"
                              sx={
                                isMobile
                                  ? { fontSize: '13px', mt: 0 }
                                  : { fontSize: '13px', mt: -2.2 }
                              }>
                              Controla regiões ? *
                            </InputLabel>
                            <Select
                              name="controlaregiao"
                              fullWidth
                              size="small"
                              required
                              value={infosConfig.controlaregiao || ''}
                              onChange={(event) => HandleInputChange(event)}>
                              <MenuItem value={'Sim'}>Sim</MenuItem>
                              <MenuItem value={'Não'}>Não</MenuItem>
                            </Select>
                          </Grid>
                        )}
                        <Grid item xs={12} md={2} sx={{ mt: 0.1 }}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Tipo tela de assinatura ? *
                          </InputLabel>
                          <Select
                            name="tipotela"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.tipotela || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Nova'}>Nova</MenuItem>
                            <MenuItem value={'Antiga'}>Antiga</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={2} sx={{ mt: 0.1 }}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Integra com a Health Map ? *
                          </InputLabel>
                          <Select
                            name="integhealthmap"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.integhealthmap || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} md={2} sx={{ mt: 0.1 }}>
                          <InputLabel
                            id="label"
                            sx={
                              isMobile
                                ? { fontSize: '13px', mt: 0 }
                                : { fontSize: '13px', mt: -2.2 }
                            }>
                            Envia e-mail de boas vindas ? *
                          </InputLabel>
                          <Select
                            name="welcome_send"
                            fullWidth
                            size="small"
                            required
                            value={infosConfig.welcome_send || ''}
                            onChange={(event) => HandleInputChange(event)}>
                            <MenuItem value={'Sim'}>Sim</MenuItem>
                            <MenuItem value={'Não'}>Não</MenuItem>
                          </Select>
                        </Grid>
                      </Grid>
                    </Box>
                  </TabPanel>
                  <TabPanel value="3">
                    <>
                      <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
                        <Button
                          variant="contained"
                          onClick={DocumentsModal}
                          sx={{ mr: 1 }}
                          startIcon={<Iconify icon="eva:plus-fill" />}>
                          Novo
                        </Button>
                        {!isMobile && (
                          <Button
                            variant="outlined"
                            onClick={getDocs}
                            sx={{ ml: 1 }}
                            startIcon={<Iconify icon="eva:refresh-outline" />}>
                            Atualizar
                          </Button>
                        )}
                      </Stack>
                      <Card>
                        <CustomGrid>
                          <DataGrid
                            dataSource={infosDocs}
                            showBorders={true}
                            remoteOperations={true}
                            wordWrapEnabled={true}
                            allowColumnResizing={true}
                            columnAutoWidth={true}
                            noDataText={'Não há documentos cadastrados'}>
                            <Column dataField="id" />
                            <Column dataField="nome" caption="Nome do documento" />
                            <Column dataField="qtde" caption="Quantidade de páginas/Documentos" />
                            <Column dataField="obrigatorio" caption="Obrigatório" />
                            <Column dataField="direcao" caption="Direção" />
                            <Column dataField="tpcontrat" caption="Tipo de contratação" />
                            {company === 'higiasaude' && (
                              <Column dataField="formato" caption="Formato da contratação" />
                            )}
                            <Column
                              dataField="Ações"
                              width={100}
                              allowSorting={false}
                              cellRender={(data) => <ActionsButtons data={data} />}
                            />
                            <SearchPanel visible={true} width={240} placeholder="Procurar..." />
                            {!isMobile && (
                              <GroupPanel
                                visible={true}
                                emptyPanelText="Arraste as colunas aqui para agrupar"
                              />
                            )}
                            <Scrolling rowRenderingMode="virtual"></Scrolling>
                            <Paging defaultPageSize={10} />
                            <Pager
                              visible={true}
                              allowedPageSizes={allowedPageSizes}
                              showPageSizeSelector={true}
                              showInfo={true}
                              showNavigationButtons={true}
                            />
                            <ColumnChooser
                              enabled={true}
                              title={'Escolher uma coluna'}
                              emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
                            />
                            <ColumnFixing enabled={true} />
                            <HeaderFilter visible={true} allowSearch={true} />
                          </DataGrid>
                        </CustomGrid>
                      </Card>
                    </>
                  </TabPanel>
                  <TabPanel value="4">
                    <Alert severity="warning">
                      Configuração de declínio de proposta. Valores acima dos limites configurados
                      resultarão em mensagem de declínio.
                    </Alert>
                    <Box sx={{ width: '100%', mt: 1, border: 1, borderColor: 'grey.200', p: 1 }}>
                      <CustomInfosForm>
                        Configure os parâmetros para declínio de propostas
                      </CustomInfosForm>
                      <Grid container spacing={2} sx={{ mt: 2 }}>
                        <Grid item xs={12} md={3}>
                          <TextField
                            name="imc_declinio"
                            fullWidth
                            label="IMC para declínio"
                            variant="outlined"
                            size="small"
                            type="number"
                            inputProps={{
                              step: '0.01',
                              min: '0',
                              max: '100'
                            }}
                            value={infosConfig.imc_declinio || ''}
                            onChange={(event) => HandleInputChange(event)}
                            helperText="IMC acima deste valor será declinado automaticamente"
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            name="idade_declinio"
                            fullWidth
                            label="Idade média para declínio"
                            variant="outlined"
                            size="small"
                            type="number"
                            inputProps={{
                              min: '0',
                              max: '120'
                            }}
                            value={infosConfig.idade_declinio || ''}
                            onChange={(event) => HandleInputChange(event)}
                            helperText="Idade média do coletivo acima deste valor será declinada"
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            name="minimo_vidas_empresarial"
                            fullWidth
                            label="Mínimo de vidas em contratos"
                            variant="outlined"
                            size="small"
                            type="number"
                            inputProps={{
                              min: '1',
                              max: '10000'
                            }}
                            value={infosConfig.minimo_vidas_empresarial || ''}
                            onChange={(event) => HandleInputChange(event)}
                            helperText="Número mínimo de vidas para contratos empresariais"
                          />
                        </Grid>
                        <Grid item xs={12} md={3}>
                          <TextField
                            name="razao_dependencia_maxima"
                            fullWidth
                            label="Razão de dependência"
                            variant="outlined"
                            size="small"
                            type="number"
                            inputProps={{
                              step: '0.01',
                              min: '0',
                              max: '100'
                            }}
                            value={infosConfig.razao_dependencia_maxima || ''}
                            onChange={(event) => HandleInputChange(event)}
                            helperText="Razão de dependência máxima permitida"
                          />
                        </Grid>
                        <Grid item xs={12} md={12}>
                          <TextField
                            name="mensagem_declinio"
                            fullWidth
                            label="Mensagem de opção de declínio"
                            variant="outlined"
                            size="small"
                            multiline
                            rows={4}
                            value={infosConfig.mensagem_declinio || ''}
                            onChange={(event) => HandleInputChange(event)}
                            helperText="Mensagem que será exibida quando uma proposta for declinada"
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  </TabPanel>
                  {values !== '5' && (
                    <Stack direction="row" justifyContent="end" sx={{ mr: 2.5, mt: 2 }}>
                      <Button
                        type="submit"
                        variant="contained"
                        size="medium"
                        color="success"
                        startIcon={<Iconify icon="eva:save-fill" />}
                        sx={{ mr: 2 }}>
                        {infosConfig.id ? 'Atualizar' : 'Salvar'}
                      </Button>
                      <Button
                        variant="contained"
                        color="error"
                        component={RouterLink}
                        to="/app/dashboard"
                        startIcon={<Iconify icon="eva:close-circle-fill" />}>
                        Cancelar
                      </Button>
                    </Stack>
                  )}
                </form>
                <TabPanel value="5">
                  <FormConfigPanel />
                </TabPanel>
              </TabContext>
            </Box>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default Config;
